import type InvoiceStatusDisplay from 'ab-enums/invoiceStatusDisplay.enum';

import type { TableQuery } from 'ab-common/dataStructures/tableQuery';

import baseRoute from '../baseRoute';

export type * from './viewModel';
export type * from './queryParams';

type RouteDefinition = `${typeof baseRoute}/invoices${`?query=${string}&startDate=${string}&endDate=${string}` | ''}`;

export const ROUTE: RouteDefinition = `${baseRoute}/invoices`;

export const URL = (startDate: string, endDate: string, tableQuery: TableQuery, invoiceStatus: Nullable<InvoiceStatusDisplay>): RouteDefinition =>
	`${baseRoute}/invoices?query=${encodeURIComponent((JSON.stringify(tableQuery)))}&startDate=${startDate}&endDate=${endDate}${invoiceStatus ? `&invoiceStatus=${invoiceStatus}` : ''}`;
